import { useCallback, useEffect } from 'react'

const useKeyboardHandle = ({
    onEscapePress,
    onEnterPress,
}: {
    onEscapePress?: () => void
    onEnterPress?: () => void
}): void => {
    const handleKeyboard = useCallback(
        (event) => {
            if (event.key === 'Escape' && onEscapePress) {
                onEscapePress()
            }
            if (event.key === 'Enter' && onEnterPress) {
                onEnterPress()
            }
        },
        [onEscapePress, onEnterPress]
    )

    useEffect(() => {
        document.addEventListener('keydown', handleKeyboard, false)
        return () => {
            document.removeEventListener('keydown', handleKeyboard, false)
        }
    }, [handleKeyboard])
}

export default useKeyboardHandle
